require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-kokomo-heritage.json") })
        }
      }, "path---articles-tags-kokomo-heritage");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-kokomo-heritage!./.cache/json/articles-tags-kokomo-heritage.json
// module id = 1876
// module chunks = 231608221292675